const useGetUrl = (
  articleType: string | null | undefined,
  slug: string | undefined,
  externalUrl?: string,
) => {
  // external url (search results use 'external' so it seems.)
  if (articleType === 'externe-link' || (articleType as string) === 'external') {
    if (!externalUrl || externalUrl.trim() === '') {
      return '/error';
    }
    return externalUrl;
  }

  // initialPath is where we are, path is where we should be
  let path = `/${articleType}/${slug}`;

  // remove '/paginas/' since those always live under root (or the last directory).
  if (path.includes('/paginas/')) {
    path = path.replace('/paginas/', '/');
  }

  return path;
};

export default useGetUrl;
